export default {
    data() {
        return {
            stripe: {
                errorMessage: {
                    DEFAULT: '処理を完了することができませんでした。入力したカード情報のご確認をお願いいたします。<br />カード情報に問題がない場合は、お手数ですが、カード会社にお問い合わせいただくか、<br/> 別のクレジットカードをご利用ください。', // Please check the card information you entered. If card information is correct, please contact your credit card company or use a different credit card.
                    G1: '処理を完了することができませんでした。入力したカード情報のご確認をお願いいたします。<br />カード情報に問題がない場合は、お手数ですが、カード会社にお問い合わせいただくか、<br/> 別のクレジットカードをご利用ください。', // Please check the card information you entered. If card information is correct, please contact your credit card company or use a different credit card.
                    G2: '処理を完了することができませんでした。時間を置いてお試しいただきますようお願いいたします。<br />解決しない場合はお手数ですが、カード会社にお問い合わせいただくか、別のクレジットカードをご利用ください。', // The process could not be completed. If the problem persists, please contact your credit card company or use a different credit card.
                    G3: '処理を完了することができませんでした。ご入力のカードはこの定期購入に対応していません。<br />お手数ですが、カード会社にお問い合わせいただくか、別のクレジットカードをご利用ください。', // The process could not be completed. The card you entered is not compatible with this subscription. We apologize for the inconvenience, please contact your credit card company or use a different credit card.
                    G4: '処理を完了することができませんでした。ご入力のカードはこの（通貨での）お支払いに対応していません。<br />お手数ですが、カード会社にお問い合わせいただくか、別のクレジットカードをご利用ください。', // The process could not be completed. The card you entered does not support payment in this currency. We apologize for the inconvenience, but please contact your credit card company or use a different credit card.
                    G5: '月額コースは、ご利用中のサブスクリプションと重複するためご購入いただけません。<br /><a href="/account">アカウントページ</a>でご利用状況をご確認ください。解決しない場合やご不明の点がある場合は、<br />お手数ですが、「英辞郎 on the WEB」お問い合わせフォームからご連絡をお願いします。' // You cannot purchase the monthly course as it overlaps with your current subscription. Please check your usage status on your account page. If the problem is not resolved, please contact us using the "Eijiro on the WEB" inquiry form.
                },
                declineCodes: {
                    authentication_required: {
                        code: 'DECLINED_01',
                        description: 'The card was declined as the transaction requires authentication.',
                        messageKey: 'G1',
                    },
                    approve_with_id: {
                        code: 'DECLINED_02',
                        description: 'The payment can’t be authorized.',
                        messageKey: 'G1',
                    },
                    call_issuer: {
                        code: 'DECLINED_03',
                        description: 'The card was declined for an unknown reason.',
                        messageKey: 'G1',
                    },
                    card_not_supported: {
                        code: 'DECLINED_04',
                        description: 'The card does not support this type of purchase.',
                        messageKey: 'G3',
                    },
                    card_velocity_exceeded: {
                        code: 'DECLINED_05',
                        description: 'The customer has exceeded the balance, credit limit, or transaction amount limit available on their card.',
                        messageKey: 'G1',
                    },
                    currency_not_supported: {
                        code: 'DECLINED_06',
                        description: 'The card does not support the specified currency.',
                        messageKey: 'G4',
                    },
                    do_not_honor: {
                        code: 'DECLINED_07',
                        description: 'The card was declined for an unknown reason.',
                        messageKey: 'G1',
                    },
                    do_not_try_again: {
                        code: 'DECLINED_08',
                        description: 'The card was declined for an unknown reason.',
                        messageKey: 'G1',
                    },
                    duplicate_transaction: {
                        code: 'DECLINED_09',
                        description: 'A transaction with identical amount and credit card information was submitted very recently.',
                        messageKey: 'G5',
                    },
                    expired_card: {
                        code: 'DECLINED_10',
                        description: 'The card has expired.',
                        messageKey: 'G1',
                    },
                    fraudulent: {
                        code: 'DECLINED_11',
                        description: 'The payment was declined because Stripe suspects that it is fraudulent.',
                        messageKey: 'G1'
                    },
                    generic_decline: {
                        code: 'DECLINED_12',
                        description: 'The card was declined for an unknown reason or Stripe Radar blocked the payment.',
                        messageKey: 'G1'
                    },
                    incorrect_number: {
                        code: 'DECLINED_13',
                        description: 'The card number is incorrect.',
                        messageKey: 'G1'
                    },
                    incorrect_cvc: {
                        code: 'DECLINED_14',
                        description: 'The CVC number is incorrect.',
                        messageKey: 'G1'
                    },
                    incorrect_pin: {
                        code: 'DECLINED_15',
                        description: 'The PIN entered is incorrect. This decline code only applies to payments made with a card reader.',
                        messageKey: 'G1'
                    },
                    incorrect_zip: {
                        code: 'DECLINED_16',
                        description: 'The postal code is incorrect.',
                        messageKey: 'G1'
                    },
                    insufficient_funds: {
                        code: 'DECLINED_17',
                        description: 'The card has insufficient funds to complete the purchase.',
                        messageKey: 'G1'
                    },
                    invalid_account: {
                        code: 'DECLINED_18',
                        description: 'The card, or account the card is connected to, is invalid.',
                        messageKey: 'G1'
                    },
                    invalid_amount: {
                        code: 'DECLINED_19',
                        description: 'The payment amount is invalid, or exceeds the amount that’s allowed.',
                        messageKey: 'G1'
                    },
                    invalid_cvc: {
                        code: 'DECLINED_20',
                        description: 'The CVC number is incorrect.'
                    },
                    incomplete_cvc: {
                        code: 'DECLINED_20',
                        description: 'The CVC number is incomplete'
                    },
                    incomplete_expiry: {
                        code: 'DECLINED_21',
                        description: 'The expiration is invalid.'
                    },
                    invalid_expiry_month: {
                        code: 'DECLINED_21',
                        description: 'The expiration month is invalid.'
                    },
                    invalid_expiry_month_past: {
                        code: 'DECLINED_21',
                        description: 'The expiration month is invalid.'
                    },
                    invalid_expiry_year: {
                        code: 'DECLINED_22',
                        description: 'The expiration year is invalid.'
                    },
                    invalid_expiry_year_past: {
                        code: 'DECLINED_22',
                        description: 'The expiration year is invalid.'
                    },
                    invalid_number: {
                        code: 'DECLINED_23',
                        description: 'The card number is incorrect.'
                    },
                    incomplete_number: {
                        code: 'DECLINED_23',
                        description: 'The card number is incomplete.'
                    },
                    invalid_pin: {
                        code: 'DECLINED_24',
                        description: 'The PIN entered is incorrect.',
                        messageKey: 'G1'
                    },

                    issuer_not_available: {
                        code: 'DECLINED_25',
                        description: 'The card was declined as the transaction requires authenticationThe card issuer couldn’t be reached, so the payment couldn’t be authorized.',
                        messageKey: 'G2'
                    },
                    lost_card: {
                        code: 'DECLINED_26',
                        description: 'The payment was declined because the card is reported lost.',
                        messageKey: 'G1'
                    },
                    merchant_blacklist: {
                        code: 'DECLINED_27',
                        description: 'The payment was declined because it matches a value on the Stripe user’s block list.',
                        messageKey: 'G1'
                    },
                    new_account_information_available: {
                        code: 'DECLINED_28',
                        description: 'The card, or account the card is connected to, is invalid.',
                        messageKey: 'G1'
                    },
                    no_action_taken: {
                        code: 'DECLINED_29',
                        description: 'The card was declined for an unknown reason.',
                        messageKey: 'G1'
                    },
                    not_permitted: {
                        code: 'DECLINED_30',
                        description: 'The payment isn’t permitted.',
                        messageKey: 'G1'
                    },
                    offline_pin_required: {
                        code: 'DECLINED_31',
                        description: 'The card was declined because it requires a PIN.',
                        messageKey: 'G1'
                    },
                    online_or_offline_pin_required: {
                        code: 'DECLINED_32',
                        description: 'The card was declined as it requires a PIN.',
                        messageKey: 'G1'
                    },
                    pickup_card: {
                        code: 'DECLINED_33',
                        description: 'The customer can’t use this card to make this payment (it’s possible it was reported lost or stolen).',
                        messageKey: 'G1'
                    },
                    pin_try_exceeded: {
                        code: 'DECLINED_34',
                        description: 'The allowable number of PIN tries was exceeded.',
                        messageKey: 'G1'
                    },
                    processing_error: {
                        code: 'DECLINED_35',
                        description: 'An error occurred while processing the card.',
                        messageKey: 'G2'
                    },
                    reenter_transaction: {
                        code: 'DECLINED_36',
                        description: 'The payment couldn’t be processed by the issuer for an unknown reason.',
                        messageKey: 'G2'
                    },
                    restricted_card: {
                        code: 'DECLINED_37',
                        description: 'The customer can’t use this card to make this payment (it’s possible it was reported lost or stolen).',
                        messageKey: 'G1'
                    },
                    revocation_of_all_authorizations: {
                        code: 'DECLINED_38',
                        description: 'The card was declined for an unknown reason.',
                        messageKey: 'G1'
                    },
                    revocation_of_authorization: {
                        code: 'DECLINED_39',
                        description: 'The card was declined for an unknown reason.',
                        messageKey: 'G1'
                    },
                    security_violation: {
                        code: 'DECLINED_40',
                        description: 'The card was declined for an unknown reason.',
                        messageKey: 'G1'
                    },
                    service_not_allowed: {
                        code: 'DECLINED_41',
                        description: 'The card was declined for an unknown reason.',
                        messageKey: 'G1'
                    },
                    stolen_card: {
                        code: 'DECLINED_42',
                        description: 'The payment was declined because the card is reported stolen.',
                        messageKey: 'G1'
                    },
                    stop_payment_order: {
                        code: 'DECLINED_43',
                        description: 'The card was declined for an unknown reason.',
                        messageKey: 'G1'
                    },
                    testmode_decline: {
                        code: 'DECLINED_44',
                        description: 'A Stripe test card number was used.',
                        messageKey: 'G1'
                    },
                    transaction_not_allowed: {
                        code: 'DECLINED_45',
                        description: 'The card was declined for an unknown reason.',
                        messageKey: 'G1'
                    },
                    try_again_later: {
                        code: 'DECLINED_46',
                        description: 'The card was declined for an unknown reason.',
                        messageKey: 'G2'
                    },
                    withdrawal_count_limit_exceeded: {
                        code: 'DECLINED_47',
                        description: 'The customer has exceeded the balance or credit limit available on their card.',
                        messageKey: 'G1'
                    },
                    setup_intent_authentication_failure: {
                        code: 'DECLINED_101',
                        description: 'The provided payment method has failed authentication.',
                        messageKey: 'G1' 
                    },
                    setup_intent_unexpected_state: {
                        code: 'DECLINED_101',
                        description: 'The SetupIntent state was incompatible with the operation you were trying to perform.',
                        messageKey: 'G1' 
                    },
                    payment_intent_authentication_failure: {
                        code: 'DECLINED_102',
                        description: 'The provided payment method has failed authentication.',
                        messageKey: 'G1' 
                    },
                    payment_intent_unexpected_state: {
                        code: 'DECLINED_102',
                        description: 'The SetupIntent state was incompatible with the operation you were trying to perform.',
                        messageKey: 'G1' 
                    },
                }
            }
        }
    },
    methods: {
        getStripeError(declineCode) {
            const errorObject = this.stripe.declineCodes[declineCode];
            if (!errorObject) return null;
            const errorMessage = errorObject.messageKey ? this.stripe.errorMessage[errorObject.messageKey] : this.stripe.errorMessage['DEFAULT'];
            const errorCode = errorObject.code ? errorObject.code : declineCode;
            const errorDescription = errorObject.description ? errorObject.description : null;
            return {
                code: errorCode,
                description: errorDescription,
                message: errorMessage
            }
        }
    }
}
